globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import { jsx as _jsx } from "react/jsx-runtime";
export function CenterCloseIcon() {
  return /*#__PURE__*/_jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.29279 4.29301C4.48031 4.10553 4.73462 4.00022 4.99979 4.00022C5.26495 4.00022 5.51926 4.10553 5.70679 4.29301L9.99979 8.58601L14.2928 4.29301C14.385 4.19749 14.4954 4.12131 14.6174 4.0689C14.7394 4.01649 14.8706 3.98891 15.0034 3.98775C15.1362 3.9866 15.2678 4.0119 15.3907 4.06218C15.5136 4.11246 15.6253 4.18672 15.7192 4.28061C15.8131 4.3745 15.8873 4.48615 15.9376 4.60905C15.9879 4.73195 16.0132 4.86363 16.012 4.99641C16.0109 5.12919 15.9833 5.26041 15.9309 5.38241C15.8785 5.50441 15.8023 5.61476 15.7068 5.707L11.4138 10L15.7068 14.293C15.8889 14.4816 15.9897 14.7342 15.9875 14.9964C15.9852 15.2586 15.88 15.5094 15.6946 15.6948C15.5092 15.8802 15.2584 15.9854 14.9962 15.9877C14.734 15.99 14.4814 15.8892 14.2928 15.707L9.99979 11.414L5.70679 15.707C5.51818 15.8892 5.26558 15.99 5.00339 15.9877C4.74119 15.9854 4.49038 15.8802 4.30497 15.6948C4.11956 15.5094 4.01439 15.2586 4.01211 14.9964C4.00983 14.7342 4.11063 14.4816 4.29279 14.293L8.58579 10L4.29279 5.707C4.10532 5.51948 4 5.26517 4 5C4 4.73484 4.10532 4.48053 4.29279 4.29301Z",
      fill: "#9CA3AF"
    })
  });
}